import { createFileRoute, useParams } from '@tanstack/react-router';

import { CustomerStatementView } from '../components/ar/CustomerStatementView';
import { PageHead } from '../components/layout';
import { useActiveCompanyId } from '../lib/queries';

export const Route = createFileRoute('/ar/statement/$customerId')({
  component: ArStatementPage,
});

export function ArStatementPage() {
  const { customerId } = useParams({ from: '/ar/statement/$customerId' });
  const companyId = useActiveCompanyId();

  return (
    <div className="page">
      <PageHead
        crumbs={['ลูกหนี้การค้า', 'ใบแจ้งยอดบัญชี']}
        title="ใบแจ้งยอดบัญชีลูกหนี้ (Statement of Account)"
      />
      <CustomerStatementView companyId={companyId} customerId={customerId} />
    </div>
  );
}
